import { render, staticRenderFns } from "./list-brand.vue?vue&type=template&id=0a252bab&scoped=true&"
import script from "./list-brand.vue?vue&type=script&lang=js&"
export * from "./list-brand.vue?vue&type=script&lang=js&"
import style0 from "./list-brand.vue?vue&type=style&index=0&id=0a252bab&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a252bab",
  null
  
)

export default component.exports